import { render, staticRenderFns } from "./PresellGood.vue?vue&type=template&id=32ac7dcf&scoped=true&"
import script from "./PresellGood.vue?vue&type=script&lang=js&"
export * from "./PresellGood.vue?vue&type=script&lang=js&"
import style0 from "./PresellGood.vue?vue&type=style&index=0&id=32ac7dcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ac7dcf",
  null
  
)

export default component.exports